import Api from '@/services/API';

export default {
  login(APIKey) {
    return Api().post('/auth/login', { APIKey });
  },
};
